﻿import { resp } from "./resp";
import { response_details_amount } from "./response_details_amount";

export class response_details {
    public paymentMethod: string | null = null;
    public transactionId: string | null = null;
    public amount: response_details_amount = new response_details_amount();
    public billToFirstName: string | null = null;
    public billToLastName: string | null = null;
    public billToAddressLine1: string | null = null;
    public billToAddressLine2: string | null = null;
    public billToAddressCity: string | null = null;
    public billToAddressState: string | null = null;
    public billToAddressCountry: string | null = null;
    public billToAddressPostalCode: string | null = null;
    public lastFourDigits: string | null = null;
}